"use strict";

if (document.querySelector('.about-page__carousel .swiper')) {
  var ambassadorsSwiper = [];
  document.querySelectorAll('.about-page__carousel .swiper').forEach(function (item, index) {
    var slider = item;
    var speed = slider.dataset.speed;
    var swiper = new Swiper(slider, {
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      slidesPerView: 1,
      loopedSlides: 2,
      spaceBetween: 20,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      breakpoints: {
        480: {
          slidesPerView: 2,
          loopedSlides: 4,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 3,
          loopedSlides: 6,
          spaceBetween: 20
        },
        992: {
          slidesPerView: 4,
          loopedSlides: 8,
          spaceBetween: 37
        }
      },
      autoplay: {
        delay: speed ? speed : '7000'
      },
      pagination: false
    });
  });
}